var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "24px",
    height: "20px",
    viewBox: "0 0 24 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-twitter") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iconmonstr-twitter-1",
    fillRule: "nonzero",
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,2.309 C23.117,2.701 22.168,2.965 21.172,3.084 C22.189,2.475 22.97,1.51 23.337,0.36 C22.386,0.924 21.332,1.334 20.21,1.555 C19.313,0.598 18.032,0 16.616,0 C13.437,0 11.101,2.966 11.819,6.045 C7.728,5.84 4.1,3.88 1.671,0.901 C0.381,3.114 1.002,6.009 3.194,7.475 C2.388,7.449 1.628,7.228 0.965,6.859 C0.911,9.14 2.546,11.274 4.914,11.749 C4.221,11.937 3.462,11.981 2.69,11.833 C3.316,13.789 5.134,15.212 7.29,15.252 C5.22,16.875 2.612,17.6 0,17.292 C2.179,18.689 4.768,19.504 7.548,19.504 C16.69,19.504 21.855,11.783 21.543,4.858 C22.505,4.163 23.34,3.296 24,2.309 L24,2.309 Z",
    id: "Shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.13b2c8c7e972438445f817e615cec80f.svg";
export { ForwardRef as ReactComponent };